import { registerPlugin } from '@capacitor/core';

interface IBluecodePlugin {
  show: () => Promise<void>;
  close: () => Promise<void>;
}

export const BluecodePlugin = registerPlugin<IBluecodePlugin>('BluecodePlugin');
